import {
	Button,
	Grid,
	Header,
	type Job,
	TraitementLong,
} from '@mairistem/composants';
import { Sens } from '@mairistem/comptabilite';
import { getErrorMessage, Icon } from '@mairistem/finances-utils';
import { downloadFile } from '@mairistem/tools';
import React from 'react';
import { toast } from 'react-toastify';
import { getPluriannuelleExportExcel } from '../../services/projet';
import './PluriannuelleHeader.css';

interface PluriannuelleHeaderProps {
	endYear: string;
	startYear: string;
}

const PluriannuelleHeader = ({
	endYear,
	startYear,
}: PluriannuelleHeaderProps) => {
	const [job, setJob] = React.useState<Job>();
	const [loading, setLoading] = React.useState(false);

	const handleErrorJob = () => {
		setJob(null);
		setLoading(false);
		toast.error('Erreur lors du traitement');
	};

	const handleExport = async () => {
		try {
			setLoading(true);
			setJob(
				await getPluriannuelleExportExcel(
					new URLSearchParams({
						anneeDebut: startYear,
						anneeFin: endYear,
						sens: Sens.DEPENSE,
					}),
				),
			);
		} catch (e) {
			toast.error(getErrorMessage(e, "Erreur lors de l'export"));
			setLoading(false);
		}
	};

	const handleFinishJob = async (finishedJob: Job) => {
		setJob(null);
		setLoading(false);

		if (finishedJob.status === 1) {
			await downloadFile(finishedJob.identifiant);
		} else {
			toast.error(finishedJob.resultat);
		}
	};

	return (
		<>
			<Grid>
				<Grid.Row>
					<Grid.Column width={13}>
						<Header>
							<Icon color="var(--accent)" iconSet="Lucide" name="TrendingUp" />
							<Header.Content>
								Programmation pluriannuelle
								<Header.Subheader>
									Vue consolidée des autorisations de programme
								</Header.Subheader>
							</Header.Content>
						</Header>
					</Grid.Column>
					<Grid.Column textAlign="right" width={3}>
						<Button
							data-testid="pluriannuelleExportButton"
							loading={loading}
							onClick={handleExport}
							primary
							size="tiny"
						>
							<Icon
								className="pluriannuelleDownloadIcon"
								color="white"
								iconSet="Lucide"
								name="Download"
								size={16}
							/>
							Exporter
						</Button>
					</Grid.Column>
				</Grid.Row>
			</Grid>
			{job && loading && (
				<TraitementLong
					identifiantJob={job?.identifiant}
					indeterminate
					onError={handleErrorJob}
					onFinish={handleFinishJob}
					title="Exportation des données vers Excel"
				/>
			)}
		</>
	);
};

export default PluriannuelleHeader;
